<template>
  <el-dialog :title="id ? '编辑项目' : '添加项目'" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="120px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="汇合地点" prop="location_detail">
          <el-input v-model="temp.location_detail" />
        </el-form-item>
        <el-form-item label="位置信息" required>
          <el-input v-model="temp.lat_and_lon.lon" placeholder="请输入经度" style="width: 150px" />
          <el-input
            v-model="temp.lat_and_lon.lat"
            placeholder="请输入纬度"
            style="width: 150px; margin-left: 10px"
          />
        </el-form-item>
        <el-form-item label="服务时长" prop="service_duration">
          <el-input v-model="temp.service_duration" style="width: 100px; margin-right: 10px" />分钟
        </el-form-item>
        <el-form-item label="团队人数" prop="user_limit">
          <el-input v-model="temp.user_limit" />
        </el-form-item>
        <el-form-item label="是否需要证件" prop="is_need_card">
          <el-radio-group v-model="temp.is_need_card">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="城市" prop="city">
          <el-select v-model="temp.city" filterable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in city_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导游服务费-包团" prop="fee_terms.guide_bao_tuan_fee">
          <el-input
            v-model="temp.fee_terms.guide_bao_tuan_fee"
            style="width: 200px; margin-right: 5px"
          />元
        </el-form-item>
        <el-form-item label="导游服务费-拼团" prop="fee_terms.guide_pin_tuan_least_num">
          <el-col :span="2">少于</el-col>
          <el-col :span="9">
            <el-form-item prop="fee_terms.guide_pin_tuan_least_num">
              <el-input v-model="temp.fee_terms.guide_pin_tuan_least_num" />
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left: 5px">人，</el-col>
          <el-col :span="9">
            <el-form-item prop="fee_terms.guide_pin_tuan_least_num_fee">
              <el-input v-model="temp.fee_terms.guide_pin_tuan_least_num_fee" />
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left: 5px">元</el-col>
        </el-form-item>
        <el-form-item label="导游服务费-拼团" prop="fee_terms.guide_pin_tuan_other_num_fee">
          <el-col :span="4">其他人数</el-col>
          <el-col :span="9">
            <el-form-item prop="fee_terms.guide_pin_tuan_least_num">
              <el-input v-model="temp.fee_terms.guide_pin_tuan_other_num_fee" />
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left: 5px">元</el-col>
        </el-form-item>
        <el-form-item label="每人耳机费用" prop="fee_terms.earphone_fee">
          <el-input
            v-model="temp.fee_terms.earphone_fee"
            style="width: 200px; margin-right: 5px"
          />元
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, add, edit } from '@/api/projects'
import { CITY_OPTIONS } from '@/utils/platform'
const rule = [{ required: true, message: '必填项不能为空' }]

export default {
  name: 'ProjectsEdit',
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      id: '',
      temp: {
        name: '',
        service_duration: '',
        user_limit: '',
        is_need_card: null,
        city: '',
        location_detail: '',
        lat_and_lon: { lat: '', lon: '' },
        fee_terms: {
          guide_bao_tuan_fee: '',
          guide_pin_tuan_least_num: '',
          guide_pin_tuan_least_num_fee: '',
          guide_pin_tuan_other_num_fee: '',
          earphone_fee: ''
        }
      },
      city_options: CITY_OPTIONS,
      rules: {
        name: rule,
        location_detail: rule,
        service_duration: rule,
        user_limit: rule,
        is_need_card: [{ required: true, message: '请选择活动资源', trigger: 'change' }],
        city: [{ required: true, message: '请选择城市', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 添加
    handleCreate() {
      this.id = ''
      this.temp = {
        name: '',
        service_duration: '',
        user_limit: '',
        is_need_card: null,
        city: '',
        location_detail: '',
        lat_and_lon: { lat: '', lon: '' },
        fee_terms: {
          guide_bao_tuan_fee: '',
          guide_pin_tuan_least_num: '',
          guide_pin_tuan_least_num_fee: '',
          guide_pin_tuan_other_num_fee: '',
          earphone_fee: ''
        }
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 编辑
    handleEdit(id) {
      getDetail(id).then((res) => {
        this.id = id
        let temp = Object.assign(this.temp, res.data)
        this.temp = {
          ...temp,
          city: res.data.city.toString()
        }
        console.log(this.temp)
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const d = JSON.parse(JSON.stringify(this.temp))
          const p = this.id ? edit(this.id, d) : add(d)
          p.then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: this.id ? '修改成功' : '添加成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
